import { Injectable } from '@angular/core';
import { vProductoModel } from '../Modelo/vProducto.model';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MensajeModel } from '../Modelo/Mensajes.model';
import { MensajeProductoModel } from '../Modelo/MensajeProductoModel';
import { String } from '../utilidades/Extensions/string-extensions';

@Injectable({
    providedIn: 'root'
})
export class CarritoDeComprasService {

    public Mensaje: MensajeModel = new MensajeModel();

    constructor(public Utilidades: UtilidadesService, private _snackBar: MatSnackBar) {
        const savedCarToParse = localStorage.getItem("CarritoCompras");

        if (!String.isNullOrWhiteSpace(savedCarToParse)) {
            this.Mensaje = <MensajeModel>JSON.parse(savedCarToParse);
		}
    }

    public AgregarProducto(item: vProductoModel): void {
        if (this.Mensaje.MensajesProductos.filter(x => x.IdProducto == item.IdProducto).length == 0) {
            let Prodcuto: MensajeProductoModel = new MensajeProductoModel();
            Prodcuto.Cantidad = 1;
            Prodcuto.IdProducto = item.IdProducto;
            Prodcuto.vProductos = item;

            this.Mensaje.MensajesProductos.push(Prodcuto);
            this.GuardarEnStorage();
            this._snackBar.open("Se ha agregado " + item.Descripcion + " al carrito de compras.", null, { duration: 3000 });
        }
        else {
            this._snackBar.open("Este producto ya existe en el carrito de compras.", null, { duration: 3000 });
		}
    }

    private GuardarEnStorage(): void {
        localStorage.setItem("CarritoCompras", JSON.stringify(this.Mensaje));
    }

    public QuitarProducto(indice: number): void {
        this.Mensaje.MensajesProductos.splice(indice, 1);
        this.GuardarEnStorage();
    }

    public Vaciar(): void {
        this.Mensaje = new MensajeModel();
        this.GuardarEnStorage();
	}
}